import { client, gql } from './Client';

export interface ReportInfoInput {
  reportName: string;
  pk_Schedule: number;
  pk_AssetInspection: number;
  assetInspectionComponentFailureId: number;
  siteId?: number;
  disciplineId?: number;
  scheduleName?: string;
  disciplineName?: string;
  assetName?: string;
  additionalNotes?: string;
  logoPathSite?: string;
  logoPathSP?: string;
  logoPathSP_Header?: string;
  logoPathSite_Header?: string;
  attachedDocuments?: string;
  fileCategoryName?: string;
  username?: string;
  hasAppendices?: boolean;
  inspectionType?: string;
  completionDate?: string | null;
  reportFileName?: string;
  startDate?: string;
  endDate?: string;
  siteName?: string;
  assetMainCategoryName?: string;
  assetCategoryName?: string;
  componentName?: string;
  isDraft?: boolean;
}

const saveReportAndGetS3PathQuery = gql`
  mutation saveReportAndGetS3Path($ReportInfoInput: ReportInfoInput) {
    saveReportAndGetS3Path(reportInfo: $ReportInfoInput)
  }
`;

const saveReportAndGetS3Path = (ReportInfoInput: ReportInfoInput) =>
  client.mutate({ mutation: saveReportAndGetS3PathQuery, variables: { ReportInfoInput } });

export { saveReportAndGetS3Path };
